import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {UserLabel, ListUserLabelsResponse} from "../http/protocol";


export class UserLabelService extends AbstractAdminEntityService<UserLabel, ListUserLabelsResponse>   {
    constructor(http : HttpService) {
        super("/userlabels", http)
    }

    getAllLabels():Promise<ListUserLabelsResponse[]> {
        return this.http.get('/userlabels/all');
    }

    getUserLabel(userLabelId:any):Promise<UserLabel> {
        return this.http.get(`/userlabels/${userLabelId}`);
    }
}